<template>
  <UiModal
    :show="showTeams"
    :title="title"
    iconType="team_1"
    @close="showTeams = false"
  >
    <div class="inner-content">
      <div class="scroll-box">
        <ul class="teams-list" v-if="teamsList.length !== 0">
          <li v-for="(item, key) in teamsList" :key="key">
            <div class="icon-bg">
              <div class="icon">
                <div
                  class="head"
                  :style="{
                    'background-image': `url(${
                      item?.avatar ? item.avatar || defaultAvatar : defaultAvatar
                    })`,
                  }"
                ></div>
                <div class="frame"></div>
              </div>
            </div>
            <div class="name">
              <div class="label-box">
                <span class="label-shadow">{{ item?.name ? item.name : "-" }}</span>
                <span class="label-text">{{ item?.name ? item.name : "-" }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </UiModal>
</template>

<script setup>
import { ref } from 'vue'
import UiModal from "@/components/ui-modal.vue";

const showTeams = ref(false);
const teamsList = ref([]);
const title = ref('参赛队伍');
const defaultAvatar = ref("https://website.xdcdn.net/poster/sausage/match/zhanduilogo/z51MQgVN.png");

function initTeams(teams, title_) {
  teamsList.value = teams;
  if(title_) {
    title.value = title_
  }

  showTeams.value = true;
}
function closeModal() {
  showTeams.value = false;

  // 关闭弹窗后，清空数据, 保持数据最新
  teamsList.value = [];
}

// 父组件(schedule/index.vue、quiz/index.vue、live/index.vue)通过 $refs.teamsModal.initTeams 调用
defineExpose({ initTeams, closeModal });
</script>

<style lang="scss" scoped>
.inner-content {
  margin: 20px 8px 32px;
  overflow: hidden;

  .scroll-box {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .teams-list {
    width: 896px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    li {
      position: relative;
      width: 194px;
      height: 218px;
      margin: 13px 15px;
      background: url(https://website.xdcdn.net/poster/58881/26match/common/PLzi7aku.jpg) center/contain no-repeat;
      @include boxShadowSet_Btn();

      .icon-bg {
        position: relative;
        width: 100%;
        height: 100%;
        .icon {
          position: absolute;
          top: 21px;
          left: 37px;
          width: 121px;
          height: 130px;
          @include avatar_icon_frame;
        }
      }

      .name {
        position: absolute;
        bottom: 0;
        width: 100%;
        font-size: 20px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        .label-box {
          .label-shadow {
            color: #333;
          }
          .label-text {
            color: #fff;
          }
        }
      }
    }
  }

  ::-webkit-scrollbar {
    display: block;
  }
}
</style>
